module.exports = __webpack_public_path__ + "img/YI.ab798230.png";